import { Schema } from 'effect';

/**
 * Every shape a window can be cut to, as the engine names them.
 *
 * Read off `/configurator/configuration-geometries`, which is the engine publishing the list as a resource of its own. Copied here rather than fetched, for the same reason {@link SideTypes} is copied: the copy is meant to fail. A shape the engine sends and this list does not have means the two have drifted, and the
 * configuration carrying it refuses to decode — in test, on the first configuration that uses it, rather than as a dialog that quietly draws the wrong window.
 *
 * Kept in the order the endpoint answers with rather than sorted, so the two can be read side by side the day one of them changes.
 */
export const GeometryShapeTypes = Schema.Literals([
	'rectangle',
	'circle',
	'arch-top',
	'chamfer-top-left',
	'chamfer-top-both',
	'chamfer-top-right',
	'chamfer-bottom-left',
	'chamfer-bottom-both',
	'chamfer-bottom-right',
	'slope-top-left',
	'slope-top-right',
	'slope-bottom-left',
	'slope-bottom-right',
	'triangle-top-left',
	'triangle-top-both',
	'triangle-top-right',
	'triangle-bottom-left',
	'triangle-bottom-both',
	'triangle-bottom-right',
	'rounded-top-left',
	'rounded-top-both',
	'rounded-top-right',
]);

/** One of the shapes a window can be cut to. */
export type IGeometryShapeType = typeof GeometryShapeTypes.Type;
